<template>
    <div class="modal-backdrop">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">编辑职工</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">

                <el-row class="row">
                    <el-col :span="12" class="item">
                        <div class="label">登录账号</div>
                        <el-input v-model="edit_loginName" placeholder="请输入登录账号" disabled></el-input>
                    </el-col>
                    <el-col :span="12" class="item">
                        <div class="label">选择角色</div>
                        <el-select v-model="edit_roleCode" placeholder="选择角色" @change="changeRole" style="width:100%">
                            <el-option
                                    v-for="item in roleList"
                                    :key="item.roleCode"
                                    :label="item.name"
                                    :value="item.roleCode">
                            </el-option>
                        </el-select>
                    </el-col>

                </el-row>

                <el-row class="row">
                    <el-col :span="12" class="item">
                        <div class="label">姓名</div>
                        <el-input v-model="edit_realName" placeholder="请输入姓名"></el-input>
                    </el-col>
                    <el-col :span="12" class="item">
                        <div class="label">手机</div>
                        <el-input v-model="edit_phone" placeholder="请输入手机"></el-input>
                    </el-col>
                </el-row>

                <el-row class="row">
                    <el-col :span="12" class="item">
                        <div class="label">职工状态</div>
                        <el-select v-model="edit_status" placeholder="选择状态" @change="changeStatus" style="margin-right: 20px">
                            <el-option
                                    v-for="item in status2"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                    <!-- <el-col :span="12" class="item">
                        <div class="label">选择政府</div>
                        <el-select v-model="edit_governmentCode" @change="changeGovernment" style="width:100%">
                            <el-option
                                    v-for="item in governmentList"
                                    :key="item.governmentCode"
                                    :label="item.name"
                                    :value="item.governmentCode">
                            </el-option>
                        </el-select>
                    </el-col> -->

                </el-row>


            </div>
            <div class="modal-footer">
                <el-button :loading="loading"  type="primary" @click.native="confirm">确认</el-button>
            </div>
        </div>

    </div>
</template>


<script>

    import {getStaffCode} from "@/utils/auth";
    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    export default {
        name: 'Edit',
        props: [],
        data() {
            return {

                loading: false,

                edit_loginName:'',
                edit_realName:'',
                edit_roleCode:'',
                edit_phone:'',
                edit_staffCode:'',
                // edit_governmentCode:'',
                edit_zoneCode:'',


                roleList:null,
                governmentList:null,

                status2: [{
                    value: 0,
                    label: '正常'
                }, {
                    value: 1,
                    label: '被禁用'
                }],
                edit_status: 0,


            }
        },
        methods: {
            init(row){
                console.log("Edit init");

                this.edit_loginName = row.loginName;
                this.edit_realName = row.realName;
                this.edit_roleCode = row.roleCode;
                this.edit_phone = row.phone;
                this.edit_status = row.status;
                this.edit_staffCode = row.staffCode;
                // this.edit_governmentCode = row.governmentCode;
                this.edit_zoneCode = row.zoneCode;

                this.getRoleList();
                this.getGovernmentList();

            },

            closeSelf() {
                this.$emit("closeEdit");
            },

            confirm(){


                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }


                if(this.edit_loginName == ''){
                    this.loading = false;
                    return;
                }
                if(this.edit_roleCode == ''){
                    this.loading = false;
                    return;
                }
                if(this.edit_realName == ''){
                    this.loading = false;
                    return;
                }
                if(this.edit_phone == ''){
                    this.loading = false;
                    return;
                }


                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+'Staff/Edit',
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),

                        loginName: this.edit_loginName,
                        realName:this.edit_realName,
                        roleCode:this.edit_roleCode,
                        phone:this.edit_phone,
                        status:this.edit_status,
                        // governmentCode:this.edit_governmentCode,
                        zoneCode:this.edit_zoneCode,

                        staffCode2:this.edit_staffCode,

                    }
                }).then( (response)=> {
                    console.log(response);
                    this.loading = false;

                    if(response.data.error == 0){
                        this.$emit("closeEdit");
                        this.$emit("getList");
                    }else{
                        this.$message(response.data.Message);
                    }

                }).catch(function (error) {
                    console.log(error);
                });

            },


            changeRole:function(selVal){
                this.edit_roleCode = selVal;
            },
            changeGovernment:function(selVal){
                this.edit_governmentCode = selVal;
            },
            changeStatus:function (selVal) {
                this.edit_status = selVal;
            },


            getRoleList(){
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Role/ListGovRole",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            var roleValue = response.data.data;

                            //roleValue=this.remove(roleValue,'商家')
                            //roleValue=this.remove(roleValue,'管理员')
                            //roleValue=this.remove(roleValue,'服务人员')
                            //roleValue=this.remove(roleValue,'超级管理员')
                            //roleValue=this.remove(roleValue,'客服')

                          roleValue = this.remove2(roleValue);

                            this.roleList=roleValue
                            //this.add_roleCode = this.roleList[0].roleCode;
                        }else if(response.data.error == 1){
                            this.$message(response.data.message);
                        }else{
                            console.log(response.data.message);
                        }

                    }
                )
            },
             remove(array,name){
                for (var i = 0; i < array.length; i++) {
                    if (array[i].name == name){
                        array.splice(i, 1);
                        return array
                    }
                    
                }
            },
          remove2(array){
            for (var i = array.length-1; i >= 0; i--) {
              if (array[i].name != '系统管理员'){
                array.splice(i, 1);
              }
            }
            return array
          },
            getGovernmentList(){
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+'Government/List',
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then((response)=> {
                    console.log(response.data);
                    if(response.data.error == 0){
                        this.governmentList = response.data.data;
                    }else if(response.data.error == 1){
                        this.$message(response.data.message);
                    }else{
                        console.log(response.data.message);
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },



        }
    }
</script>


<style>

</style>
